import { render, staticRenderFns } from "./Catogary.vue?vue&type=template&id=461b929c&scoped=true&lang=html"
import script from "./Catogary.vue?vue&type=script&lang=js"
export * from "./Catogary.vue?vue&type=script&lang=js"
import style0 from "./Catogary.vue?vue&type=style&index=0&id=461b929c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461b929c",
  null
  
)

export default component.exports